import { CloseOutlined, MoveToInboxOutlined, OutboxOutlined } from '@mui/icons-material';
import { Badge, Box, Drawer, IconButton, Tab, Tabs, Typography } from '@mui/material';
import React from 'react';
import MessageCard from './MessageCard';

interface MessagesDrawerProps {
  open: boolean;
  onClose: () => void;
  propertyTitle?: string;
  unprocessedMessages: any[];
  processedMessages: any[];
  messagesLoading: boolean;
  tab: number;
  onTabChange: (tab: number) => void;
  onMoveMessage: (msgId: string, msgData: any, fromCollection: string, toCollection: string) => void;
  onAddClient?: (msg: any) => void;
  onAssignClient?: (msg: any) => void;
}

const MessagesDrawer: React.FC<MessagesDrawerProps> = ({
  open, onClose, propertyTitle,
  unprocessedMessages, processedMessages, messagesLoading,
  tab, onTabChange, onMoveMessage, onAddClient, onAssignClient,
}) => (
  <Drawer
    anchor="left"
    open={open}
    onClose={onClose}
    PaperProps={{ sx: { width: { xs: '100%', sm: 420 }, p: 0, top: '60px', height: 'calc(100% - 60px)' } }}
  >
    <Box sx={{ p: 2, pb: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography variant="h6" fontWeight={700}>
        رسائل: {propertyTitle}
      </Typography>
      <IconButton onClick={onClose} size="small">
        <CloseOutlined />
      </IconButton>
    </Box>
    <Tabs
      value={tab}
      onChange={(_, v) => onTabChange(v)}
      variant="fullWidth"
      sx={{ borderBottom: 1, borderColor: 'divider' }}
    >
      <Tab
        label={
          <Badge badgeContent={unprocessedMessages.length} color="error" sx={{ '& .MuiBadge-badge': { ml: 1 } }}>
            <span>غير معالجة</span>
          </Badge>
        }
      />
      <Tab label={`معالجة (${processedMessages.length})`} />
    </Tabs>

    {messagesLoading ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <Typography color="text.secondary">جارٍ التحميل...</Typography>
      </Box>
    ) : (
      <Box sx={{ overflow: 'auto', flex: 1 }}>
        {tab === 0 && (
          unprocessedMessages.length === 0 ? (
            <Box sx={{ py: 6, textAlign: 'center' }}>
              <Typography color="text.secondary">لا توجد رسائل غير معالجة</Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
              {unprocessedMessages.map((msg) => {
                const { id, ...msgData } = msg;
                return (
                  <MessageCard
                    key={id}
                    msg={msg}
                    actionTooltip="تمت المعالجة"
                    actionColor="success"
                    actionIcon={<MoveToInboxOutlined fontSize="small" />}
                    onAction={() => onMoveMessage(id, msgData, 'unprocessed_messages', 'processed_messages')}
                    onAddClient={onAddClient}
                    onAssignClient={onAssignClient}
                  />
                );
              })}
            </Box>
          )
        )}
        {tab === 1 && (
          processedMessages.length === 0 ? (
            <Box sx={{ py: 6, textAlign: 'center' }}>
              <Typography color="text.secondary">لا توجد رسائل معالجة</Typography>
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, p: 2 }}>
              {processedMessages.map((msg) => {
                const { id, ...msgData } = msg;
                return (
                  <MessageCard
                    key={id}
                    msg={msg}
                    actionTooltip="إرجاع لغير المعالجة"
                    actionColor="warning"
                    actionIcon={<OutboxOutlined fontSize="small" />}
                    onAction={() => onMoveMessage(id, msgData, 'processed_messages', 'unprocessed_messages')}
                    onAddClient={onAddClient}
                    onAssignClient={onAssignClient}
                  />
                );
              })}
            </Box>
          )
        )}
      </Box>
    )}
  </Drawer>
);

export default MessagesDrawer;
